// extracted by mini-css-extract-plugin
export default {"gradientIconButton":"AddConversationButton_gradientIconButton__T-oIR","ninjaIcon":"AddConversationButton_ninjaIcon__-1jMr"};